import http from '@http'

// 获取列表
export function getPage(data) {
  return http.get('/dataConfig/page', data, { baseURL: '/gateway' })
}

// 添加数据配置
export function addConfig(data) {
  return http.post('/dataConfig/add', data, { baseURL: '/gateway' })
}

// 删除数据配置
export function deleteConfig(data) {
  return http.delete(`/dataConfig/delete/${data.id}`, {}, { baseURL: '/gateway' })
}

// 修改数据配置
export function updateConfig(data) {
  return http.put('/dataConfig/update', data, { baseURL: '/gateway' })
}

// 修改排序
export function updateSorts(data) {
  return http.post('/dataConfig/updateSorts', data, { baseURL: '/gateway' })
}

// 单个查询数据配置
export function getDetail(data) {
  return http.get(`/dataConfig/get/${data.id}`, {}, { baseURL: '/gateway' })
}

// 查询系统list
export function getAppList(data) {
  return http.get('/dingTalk/role/getAppList', data, { baseURL: '/gateway' })
}

// 查询角色
export function getAppRoleList(data) {
  return http.get('/dingTalk/role/getAppRoleList', data, { baseURL: '/gateway' })
}
